module.exports = __webpack_public_path__ + "img/fram1.acc3378b.png";